import $ from "jquery";
import Dropzone from "dropzone";

const dropzone = () => {
    const init = () => {
        execute();
    };

    const execute = () => {
        const el = {
            button: ".js-ChangeTab",
            inputUpload: ".js-DropzoneUpload",
            placeholder: ".js-PlaceholderUpload",
            addIcon: ".js-AddIcon",
            maxNumber: ".js-maxPhoto",
            errorMessage: ".dz-error-message span[data-dz-errormessage]",
            imagesDataInput: "#images_upload",
            myAccountInfoCar: ".SingleInfoCarForm__Foto",
            buttonNextSubmit:
                "#js_btn_save_product_data, .UploadPhotoSection .SellTheCar__Button__Next",
        };

        if ($(el.placeholder).length === 0) return;

        const originalURL = window.location.href;
        // Create an anchor element to parse the URL
        const parser = document.createElement("a");
        parser.href = originalURL;

        // DROPZONE HANDLER
        // let fileCount = 0;
        const maxFilesize = 5; //in MiB not MB

        Dropzone.autoDiscover = false;

        if ($("#section-upload_photo .SellTheCar__Button__Next").length > 0) {
            $("#section-upload_photo .SellTheCar__Button__Next ").prop(
                "disabled",
                true,
            );
        }

        new Dropzone(el.inputUpload, {
            // eslint-disable-next-line
            url: themeObj.ajaxUrl, //change this based on class-return-upload.php location
            maxFilesize: maxFilesize,
            paramName: "file",
            acceptedFiles: "image/jpg, image/jpeg, image/png",
            addRemoveLinks: true,
            init: function () {
                const IsImageEmpty = () => {
                    const el = {
                        inputUpload: ".js-DropzoneUpload",
                        btnAddPhoto: ".UploadPhoto__Form__UploadWrapper__Add",
                    };

                    const html = `<div class="UploadPhoto__Form__UploadWrapper__Add js-AddIcon dz-message">
                                    <div class="UploadPhoto__Form__UploadWrapper__Add__Image">
                                        <svg class="ic-plus" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12 4V20M20 12L4 12" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
                                        </svg>
                                    </div>
                                </div>`;

                    if ($(el.btnAddPhoto).length > 0) {
                        $(el.btnAddPhoto).remove();
                    }

                    if (this.files.length > 0) {
                        $(el.inputUpload).append(html);
                    }
                };

                this.on("addedfile", function (file) {
                    //Here to handling when file added

                    file.action =
                        themeObj.selling_form.action.action_upload_product; // eslint-disable-line
                    file.nonce = themeObj.selling_form.nonce; // eslint-disable-line

                    IsImageEmpty();
                });

                this.on("removedfile", function (file) {
                    $(el.buttonNextSubmit).removeAttr("disabled");

                    const invalidPhotos = this.files.filter(
                        (remainingFile) =>
                            remainingFile.size > 5 * 1024 * 1024 &&
                            (remainingFile.type !== "image/jpg" ||
                                remainingFile.type !== "image/jpeg" ||
                                remainingFile.type !== "image/png"),
                    );

                    if (invalidPhotos.length > 0) {
                        // Handle the case where there are remaining invalid photos
                        $(el.buttonNextSubmit).attr("disabled", true);
                    }

                    if (!file.fileid) {
                        $("#" + file.upload.uuid).remove();
                        const ajax_data = {
                            path: $("#" + file.upload.uuid).data("path"),
                            file_id: $("#" + file.upload.uuid).data("file_id"),
                            nonce: themeObj.selling_form.nonce, // eslint-disable-line
                            action: themeObj.selling_form.action // eslint-disable-line
                                .action_remove_product,
                        };
                        $.ajax({
                            type: "post",
                            url: themeObj.ajaxUrl, // eslint-disable-line
                            data: ajax_data,
                        });
                    } else {
                        const element = `<input name="photosurldelete[]" value="${file.fileid}" hidden>`;
                        $("#url_image").append(element);
                    }

                    IsImageEmpty();
                });

                this.on("sending", function (file, xhr, formData) {
                    formData.append("action", file.action);
                    formData.append("nonce", file.nonce);
                });

                this.on("success", function (file, response) {
                    const input = `<input name="photosurl[]" value="${response.data.url}" data-file_id="${response.data.id}" data-path="${response.data.path}" id="${file.upload.uuid}" hidden>`;

                    $("#url_image").append(input);
                });
                this.on("complete", function () {
                    if (
                        this.getUploadingFiles().length === 0 &&
                        this.getQueuedFiles().length === 0
                    ) {
                        if (
                            $(
                                "#section-upload_photo .SellTheCar__Button__Next ",
                            ).length > 0
                        ) {
                            $(
                                "#section-upload_photo .SellTheCar__Button__Next",
                            ).prop("disabled", false);
                        }
                    }
                });

                if ($(el.myAccountInfoCar).length > 0) {
                    const imagesObject = $(el.imagesDataInput).val();
                    let jsonImage = JSON.parse(imagesObject);
                    // console.log(JSON.parse(imagesObject));

                    // Add existing files into dropzone
                    for (let i = 0; i < jsonImage.length; i++) {
                        const file = jsonImage[i];

                        // Create a mock file object
                        const mockFile = {
                            name: file.name, // Customize as needed
                            size: file.size, // Customize as needed
                            type: file.type, // Customize as needed
                            fileid: file.id,
                            status: Dropzone.ADDED,
                            accepted: true,
                        };

                        // Call relevant Dropzone functions
                        this.files.push(mockFile);
                        this.emit("addedfile", mockFile);
                        this.emit("thumbnail", mockFile, file.url); // Assuming you have the image URL
                        this.emit("complete", mockFile);

                        $(".dz-progress").css("opacity", "0");

                        // Log the file object for debugging
                    }
                }
            },
            complete: function (file) {
                const size = file.size / 1024 / 1024;
                const sizeRounded = size.toFixed(2);
                const maxSize = maxFilesize * 1024 * 1024;

                if (file.size > maxSize) {
                    $(el.buttonNextSubmit).attr("disabled", true);
                    $(file.previewElement)
                        .find(el.errorMessage)
                        .text(
                            `Bestand is te groot (${sizeRounded}MiB). Maximale bestandsgrootte: ${maxFilesize}MiB.`,
                        );
                    return false;
                }

                if (
                    file.type !== "image/jpg" &&
                    file.type !== "image/jpeg" &&
                    file.type !== "image/png"
                ) {
                    $(el.buttonNextSubmit).attr("disabled", true);
                    $(file.previewElement)
                        .find(el.errorMessage)
                        .text("Je kunt geen bestanden van dit type uploaden.");
                    return false;
                }
            },
            success: function (file) {
                if (file.previewElement) {
                    $(".dz-progress").css("opacity", "0");
                    return file.previewElement.classList.add("dz-success");
                }
            },
        });

        $(document).on("click", ".js-AddIcon", function () {
            $(el.inputUpload).trigger("click");
        });
    };

    init();
};

try {
    dropzone();
} catch (error) {
    console.error("dropzone: ", error);
}
